/** 方便迁移，暂时单独文件 */
export interface AppearanceTheme {
  /** 整体主题色是亮色还是暗色 */
  readonly type: "light" | "dark";
  /** 背景色 */
  readonly "navigation.backgroundColor": string;
  /** 背景图片 */
  readonly "navigation.backgroundImage"?: string;
  /** 应用名称颜色 */
  readonly "navigation.appName.color": string;
  /** 应用下拉框底部阴影 */
  readonly "navigation.appDropdown.shadow": string;
  /** 应用左右切换icon颜色 */
  readonly "navigation.appDropdown.arrowIcon.color": string;
  /** 应用左右切换icon hover颜色 */
  readonly "navigation.appDropdown.arrowIcon.hoverColor": string;
  /** 应用左右切换icon 背景渐变色，初始颜色总是透明的 */
  readonly "navigation.appDropdown.arrowIcon.backgroundColorEnd": string;
  /** 应用卡片阴影 */
  readonly "navigation.appDropdown.card.boxShadow": string;
  /** 导航条操作区域颜色 */
  readonly "navigation.operation.color": string;
  /** 菜单背景色 */
  readonly "aside.backgroundColor": string;
  /** 菜单背景图片 */
  readonly "aside.backgroundImage"?: string;
  /** 菜单展开收起icon颜色 */
  readonly "aside.expandIcon.color": string;
  /** 菜单展开收起icon背景色 */
  readonly "aside.expandIcon.backgroundColor": string;
  /** 菜单与菜单之间分割线颜色 */
  readonly "aside.menu.outline": string;
  /** 菜单文字颜色 */
  readonly "aside.menu.title.color": string;
  /** 菜单文字 hover颜色, 线性文字色，所以有start与end */
  readonly "aside.menu.title.hoverColorStart": string;
  /** 菜单文字 hover颜色, 线性文字色，所以有start与end */
  readonly "aside.menu.title.hoverColorEnd": string;
  /** 菜单文字 选中颜色 */
  readonly "aside.menu.title.selectedColor": string;
  /** 子菜单文字颜色 */
  readonly "aside.menu.subTitle.color": string;
  /** 子菜单选中颜色，线性文字色，所以有start与end */
  readonly "aside.menu.subTitle.selectedColorStart": string;
  /** 子菜单选中颜色，线性文字色，所以有start与end */
  readonly "aside.menu.subTitle.selectedColorEnd": string;
  /** 菜单hover背景色，线性背景色，所以有start与end */
  readonly "aside.menu.hoverBackgroundColor": string;
  /** 菜单选中背景色，线性背景色，所以有start与end */
  readonly "aside.menu.selectedBackgroundColorStart": string;
  /** 菜单选中背景色，线性背景色，所以有start与end */
  readonly "aside.menu.selectedBackgroundColorEnd": string;
  /** 收藏列表表头文字颜色 */
  readonly "aside.collect.title.color": string;
  /** 收藏列表文字颜色 */
  readonly "aside.collectItem.title.color": string;
}

export type GwAppearanceTheme = Record<
  `wbuc.appearance.${keyof AppearanceTheme}`,
  string
>;

export const addPrefixTheme = (theme: AppearanceTheme | undefined) => {
  if (!theme) {
    return {};
  }
  return Object.entries(theme).reduce((prev, [k, v]) => {
    prev[`wbuc.appearance.${k}`] = v;
    return prev;
  }, {} as GwAppearanceTheme);
};
